import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, CollapsibleItem } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { PersonCheckIcon } from '../../RotaBuilder/common/components/icons'

export type MissingAllocationListItemProps = {
  openAllocationWindow?: () => void
}

export const MissingAllocationListItem = ({
  openAllocationWindow
}: MissingAllocationListItemProps) => {
  const { t } = useTranslation()

  return (
    <MissingCollapsibleSection
      header={() => (
        <Wrapper>
          <StyledQuestionOutlined size={22} color="" />
          <MissingText weight="medium">{t('MISSING_ALLOCATION')}</MissingText>
          {openAllocationWindow && (
            <AllocateTeamMemberButton
              variant="text"
              onClick={openAllocationWindow}
            >
              <PersonCheckIcon color="currentColor" />
              {t('ALLOCATE')}
            </AllocateTeamMemberButton>
          )}
        </Wrapper>
      )}
      defaultCollapsed
    />
  )
}

const MissingCollapsibleSection = styled(CollapsibleItem)`
  border: 1px dashed ${({ theme }) => theme.color.neutral.color8};
  border-radius: 16px;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`

const AllocateTeamMemberButton = styled(Button)`
  color: ${(props) => props.theme.color.neutral.color4};
`

const MissingText = styled(Text)`
  color: ${({ theme }) => theme.color.status.warning};
  margin-right: auto;
  margin-left: 8px;
`

const StyledQuestionOutlined = styled(QuestionCircleOutlined)`
  color: ${(props) => props.theme.color.status.warning};

  svg {
    width: 22px;
    height: 22px;
    background-color: ${(props) => props.theme.color.neutral.color9};
    border-radius: 9999px;
    overflow: hidden;
  }
`
